import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  hasConsent, 
  setConsent, 
  isConsentValid, 
  CONSENT_LEVELS
} from '../utils/cookieUtils';
import { initializeScripts } from '../utils/scriptLoader';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    // Check if user has already given valid consent
    if (!hasConsent() || !isConsentValid()) {
      setShowBanner(true);
    } else {
      setConsentGiven(true);
    }
  }, []);

  const acceptAll = () => {
    setConsent(CONSENT_LEVELS.ALL);
    setShowBanner(false);
    setConsentGiven(true);
    // Reinitialize scripts with new consent
    setTimeout(() => initializeScripts(), 100);
  };

  const acceptEssential = () => {
    setConsent(CONSENT_LEVELS.ESSENTIAL);
    setShowBanner(false);
    setConsentGiven(true);
    // Reinitialize scripts with new consent
    setTimeout(() => initializeScripts(), 100);
  };

  if (!showBanner || consentGiven) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(255, 255, 255, 0.75)',
      color: '#333',
      padding: '20px',
      zIndex: 9999,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
      borderTop: '2px solid #FFD84D',
      backdropFilter: 'blur(10px)'
    }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8">
            <h5 style={{color: '#1a1a1a', marginBottom: '10px', fontSize: '18px', fontWeight: '600'}}>
              🍪 Utilizzo dei Cookie
            </h5>
            <p style={{marginBottom: '15px', fontSize: '14px', lineHeight: '1.5', color: '#666'}}>
              Utilizziamo solo cookie essenziali per il funzionamento del sito. Non raccogliamo dati personali 
              né utilizziamo cookie di tracciamento. Per maggiori informazioni, consulta la nostra{' '}
              <Link to="/cookies" style={{color: '#FFD84D', textDecoration: 'underline'}}>
                Cookie Policy
              </Link>.
            </p>
            <p style={{marginBottom: '0', fontSize: '12px', color: '#999', fontStyle: 'italic'}}>
              Cliccando su uno dei pulsanti qui sotto, accetti la nostra gestione dei cookie in conformità con il GDPR.
            </p>
          </div>
          <div className="col-lg-4 text-lg-end">
            <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'flex-end'}}>
              <button
                onClick={acceptEssential}
                aria-label="Accetta i cookie essenziali necessari per il funzionamento del sito"
                style={{
                  padding: '10px 20px',
                  background: '#FFD84D',
                  color: '#000',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.background = '#FFA500'}
                onMouseOut={(e) => e.target.style.background = '#FFD84D'}
                title="Accetta i cookie essenziali necessari per il funzionamento del sito"
              >
                Accetta Essenziali
              </button>
              <button
                onClick={acceptAll}
                aria-label="Accetta tutti i tipi di cookie (se implementati in futuro)"
                style={{
                  padding: '10px 20px',
                  background: '#1a1a1a',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.background = '#333'}
                onMouseOut={(e) => e.target.style.background = '#1a1a1a'}
                title="Accetta tutti i tipi di cookie (se implementati in futuro)"
              >
                Accetta Tutti
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
